import { createViewWelcome } from "@/ui/views";
import type { TCompositionDeps } from "./types";

/**
 * The welcome page reads only the signed-in user's effective company and its
 * customer module, both already in the auth slice.
 */
export function wireWelcome({ useAppStore }: TCompositionDeps) {
    const ViewWelcome = createViewWelcome({
        useCases: () => ({
            useCompanyName: () =>
                useAppStore(
                    (state) => state.effectiveCompanyName ?? state.user?.companyName ?? null,
                ),
            useCustomerModuleName: () =>
                useAppStore((state) => state.user?.customerModule?.displayName ?? null),
        }),
    });
    return { ViewWelcome };
}
